'use client';

import { Rating as MUIRating, RatingProps as MUIRatingProps, SvgIcon, createSvgIcon } from '@mui/material';
import classNames from 'classnames';

import typography from '@/styles/typography.module.scss';

import Rounded from './assets/rounded.svg?component';
import Sharp from './assets/sharp.svg?component';
import styles from './rating.module.scss';

const ratingColors = {
  gray: styles.ratingColorGray,
  white: styles.ratingColorWhite,
};

export interface RatingProps extends Omit<MUIRatingProps, 'size'> {
  wrapperClassName?: classNames.ArgumentArray | classNames.Argument;
  decimalSign?: string;
  starType?: 'rounded' | 'sharp';
  // TODO make it as variants/theme via css
  showAmount?: boolean;
  size?: number;
  spacing?: number;
  ratingColor?: keyof typeof ratingColors;
  starsColor?: 'gold' | 'blue';
}

export const Rating = ({
  value,
  precision = 0.5,
  max = 5,
  wrapperClassName,
  decimalSign = '.',
  showAmount = true,
  size = 16,
  spacing = 0,
  ratingColor = 'gray',
  starsColor = 'blue',
  starType = 'rounded',
  ...rest
}: RatingProps) => {
  const formattedRating = value?.toFixed(1).replace('.', decimalSign);
  const { className: ratingClassName, ...ratingProps } = rest;

  const StarComponent = starType === 'rounded' ? Rounded : Sharp;

  return (
    <div
      className={classNames(
        styles.ratingContainer,
        { [styles.ratingGold]: starsColor === 'gold' },
        wrapperClassName,
      )}
    >
      {showAmount && formattedRating ? (
        <span className={classNames(typography.bodyS, styles.ratingAmount, ratingColors[ratingColor])}>
          {formattedRating}
        </span>
      ) : null}
      <MUIRating
        name="read-only"
        className={classNames(styles.ratingContainer, ratingClassName)}
        value={value}
        precision={precision}
        max={max}
        style={{
          gap: spacing,
        }}
        readOnly
        emptyIcon={<StarComponent style={{ width: size, height: 'auto' }} />}
        icon={<StarComponent style={{ width: size, height: 'auto' }} />}
        {...ratingProps}
      />
    </div>
  );
};
